import { GalleryCard, GalleryCardProps, GalleryWithInfo } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface GalleryCardAttributes extends Omit<GalleryCardProps, 'image' | 'pills'> {
  paragraph?: React.ReactNode
  image: {
    id: number
    url: string
  }
  pills: string[]
}

export interface IAttributes extends ICTAAttributes {
  title: React.ReactNode
  paragraph: React.ReactNode
  background: 'white' | 'blue'
  cards: GalleryCardAttributes[]
}

const GalleryWithInfoSectionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const { callToAction } = useCTAAttributes(attributes)

  return (
    <GalleryWithInfo
      title={attributes.title}
      paragraph={typeof attributes.paragraph === 'string' ? parse(attributes.paragraph) : attributes.paragraph}
      background={attributes.background}
      callToAction={callToAction}
    >
      {attributes.cards.map((card, index) => (
        <GalleryCard
          key={index}
          {...card}
          image={card?.image?.url ? <Image src={card?.image?.url} /> : null}
          pills={card.pills.map((it) => ({ text: it }))}
        />
      ))}
    </GalleryWithInfo>
  )
}

const Image = styled.img`
  height: auto;
  max-width: 100%;
`

export default GalleryWithInfoSectionBlock
